import './RequirementsSection.less';
import React, {useState, useEffect} from 'react';
import __ from "../../../i18n";
import Icon from "../../../../bootstrap/components/icon/Icon";


export default function RequirementsSection({requirements}) {

    return <div className="requirements-section">
        <h2 className="title">{__('Requirements')}</h2>
        <ul>
            {
                requirements.map((text, index) => <li key={index}>
                    <div className="ic-holder">
                        <Icon name="disc"/>
                    </div>
                    <span className="text">{text}</span>
                </li>)
            }
        </ul>
    </div>;
}
